package org.hs_soft.runmynesto.pages.home.sub_page.product.mvi

import org.hs_soft.runmynesto.domain.model.home.media_center.tabs.media.app_constants.LoadAppConstant
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.Properties
import org.hs_soft.runmynesto.domain.model.home.product.products_list_model.ProductItem
import org.hs_soft.runmynesto.domain.model.home.product.ProductInfoHeaderEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.SpecialPriceItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.checked_ingredients_list.CheckedIngredient
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_allergen.ingeredient_list.Ingredients
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.PriceTypeEnum
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price.special_price.GetSpecialPrice
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.chat_model.ChatMessagesModel
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_product_general.sale_group.SaleItem
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.kitchen_info.ProductAdditions
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.printer_location.PrinterLocation
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.restaurant_data.GetRestaurant
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.FixProduct
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.ProductSets
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.SetModel
import org.hs_soft.runmynesto.domain.model.home.template.GridItemsFilterEnum
import org.hs_soft.runmynesto.domain.model.home.template.product_categories.TemplateCategoryModel
import org.hs_soft.runmynesto.domain.model.home.user.tabs.user_checkout.user_checkout_model.Children

data class ProductState(
    val selectedTab: ProductInfoHeaderEnum = ProductInfoHeaderEnum.GENERAL,
    val productsInfo:List<ProductItem> = listOf(),
    val priceLevels:List<String?> ?=null,
    val productSets:ProductSets?=null,
    val showDeleteProductSetDialog:Boolean=false,
    val deleteProductSetLoading: Boolean=false,
    val selectedProductSet: SetModel?=null,
    val productCategoryListLoading:Boolean=false,
    val errorInfo:String?=null,
    val priceType:PriceTypeEnum=PriceTypeEnum.INDIVIDUAL_PRICE,
    val showDeletePriceDialog:Boolean=false,
    val deletePriceLoading:Boolean=false,
    val createCustomAllergeneLoading:Boolean=false,
    val showCreateCustomAllergeneDialog:Boolean=false,
    val kitchenInfo:List<ProductAdditions?>?=null,
    val templateCategoryList:List<TemplateCategoryModel>?=null,
    val ingredients:List<Ingredients> ?=null,
    val checkedIngredients:List<CheckedIngredient?> ?= listOf(),
    val restaurantData: GetRestaurant?=null,
    val unitSells : List<LoadAppConstant>?=null,
    val selectedProduct: GetProduct?=null,
    val selectedFixedProductSet: FixProduct?=null,
    val showAddNewAlergeneComponent:Boolean=false,
    val showAddPriceDialog:Boolean=false,
    val selectedSaleGroupId:String?=null,
    val companyProfileId:String="",
    val properties: Properties?=null,
    val cashList: List<Children> ?= null,
    val productSalesGroup:List<SaleItem> ?=null,
    val checkOutExpandAll:Boolean=false,
    val checkOutSearchValue:String="",
    val createSpecialPriceLoading:Boolean=false,
    val collectMinOrder:String="",
    val collectMaxOrder:String="",
    val collectTimeDaysLead:String="",
    val printersLocation:List<PrinterLocation?> ? =null,
    val selectedVat:String ?=null,
    val selectedVat2:String ?=null,
    val restaurantTempItemsDescendingSort:Boolean ?=null,
    val firstPageActive:Boolean=true,
    val mainGridSearchValue:String="",
    val generalDataLoading:Boolean=false,
    val isDataAssistantDatabaseLoading:Boolean=false,
    val isMainGridNameSortedAsc:Boolean=false,
    val isMainGridNumberSortedAsc:Boolean=false,
    val showMainGridNumberSortIcon:Boolean=false,
    val showMainGridNameSortIcon:Boolean=false,
    val selectedPrice: GetSpecialPrice?=null,
    val newRecordName:String="",
    val newRecordNumber:String="",
    val showGenerateAIImgDialog:Boolean=false,
    val showDataAssistantDialog:Boolean=false,
    val imageAiGeneratorDescription: String?=null,
    val alternativeArticleName:String?=null,
    val specialPrices:List<SpecialPriceItem?>? =null,
    val submitGeneratedImgLoading:Boolean=false,
    val answerAIGeneratorQuestion: String="",
    val chatMessages: ChatMessagesModel = ChatMessagesModel(messages = mutableListOf()),
    val isDataAssistantAIGeneratorLoading:Boolean=false,
    val sendQuestionButtonIsClickable:Boolean=true,
    val speechLanguage:String?=null,
    val cashBidImgAIGeneratorUrl:String?=null,
    val isImageAiGeneratorLoading:Boolean=false,
    val isAddNewRecordSubmitClickable:Boolean=false,
    val showAddRecordDialog:Boolean=false,
    val showProductItemsFilterComponent:Boolean=false,
    val selectedProductFilterItemsType: GridItemsFilterEnum = GridItemsFilterEnum.ACTIVE_ITEMS,
    val showKitchenAddOrEditItemDialog:Boolean=false,
    val selectedKitchenInfoItem:ProductAdditions?=null,
    val showDeleteKitchenItemDialog:Boolean=false,
    val kitchenInfoDialogLoading:Boolean=false,
    val virtualCardInfo: GetVirtualCardConfig?=null,
    val addNewProductLoadingProgressBar:Boolean=false,
    val deleteKitchenItemLoading:Boolean=false,

    val showCreateNewProductSetDialog:Boolean=false,
    val createNewProductSetLoading:Boolean=false,

    val showAddProductFixDialog:Boolean=false,
    val submitAddEditProductFixLoading:Boolean=false,
    val showDeleteFixedProductDialog:Boolean=false,
    val deleteFixedProductLoading:Boolean=false,
    val showEditProductFixDialog:Boolean=false,


)